module.exports = __webpack_public_path__ + "img/add-group-icon.7ad58958.svg";